import React, { FC } from 'react';

import { TypographyVariants } from 'constants/shared/typography';
import { ModalWindow, SnippetLayout } from 'shared-components';
import Typography from 'shared-components/Typography';

interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
  name: string;
  info: string | null;
  isLoading?: boolean;
}

const LeadMoreInfoModal: FC<Props> = ({ name, isOpen, onClose, info, isLoading }) => {
  return (
    <>
      <ModalWindow
        className='min-w-[70%] 2xl:min-w-[1048px]'
        wrapperClassName=' pt-14'
        onClose={onClose}
        isOpen={isOpen}
      >
        {!info || isLoading ? (
          <div>There is no info to show</div>
        ) : (
          <>
            <Typography tag='h5' variant={TypographyVariants.MEDIUM}>
              Showing: <span className='inline font-normal text-violet-600'> {name} </span>
            </Typography>
            <div className='flex flex-wrap xl:flex-nowrap mt-6'>
              <SnippetLayout
                title='Reason for Interest'
                className='w-full min-w-[300px] '
                childrenClassName='flex flex-wrap gap-y-6'
              >
                <Typography className='mt-1'>{info}</Typography>
              </SnippetLayout>
            </div>
          </>
        )}
      </ModalWindow>
    </>
  );
};

export default LeadMoreInfoModal;
